module.exports = __webpack_public_path__ + "static/media/news_iocn.bc6c6f88.png";